import type { ReactNode } from 'react';
import { cn } from '@tsgecart/ui';

export interface AdminSectionCardProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  /** Heading level for the title -- callers compose the page's heading outline (Part 16 "semantic headings"), so this is never hardcoded to one level. */
  headingLevel?: 'h2' | 'h3';
}

/** The base card shell every dashboard widget (stat grid, chart, list) is built from -- rounded, restrained shadow, spacious padding, matching the established TSG eCart surface style. */
export function AdminSectionCard({
  title,
  description,
  actions,
  children,
  className,
  headingLevel = 'h2',
}: AdminSectionCardProps) {
  const Heading = headingLevel;
  return (
    <section className={cn('rounded-2xl border border-gray-100 bg-white p-5 shadow-sm', className)}>
      <div className="mb-4 flex items-start justify-between gap-4">
        <div>
          <Heading className="text-base font-semibold text-gray-900">{title}</Heading>
          {description && <p className="mt-0.5 text-sm text-gray-500">{description}</p>}
        </div>
        {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
      </div>
      {children}
    </section>
  );
}
